import { lazy, memo, Suspense } from 'react';

import { WorkspaceAgentPendingPill } from '~/components/v2/components/workspace/workspace-agent-panel/components/shared/WorkspaceAgentPendingPill';

const ShowcaseMoniker = lazy(async () => {
  const { PrivateWorkspaceAgentPanelMessageShowcaseMoniker } = await import(
    '~/components/v2/components/workspace/workspace-agent-panel/components/messages/PrivateWorkspaceAgentPanelMessageShowcaseMoniker'
  );

  return { default: PrivateWorkspaceAgentPanelMessageShowcaseMoniker };
});

export type PrivateWorkspaceAgentTableShowcaseMonikerProps = {
  collectionId: string;
};

/**
 * Agent table cells may mount many rows where no cell references a showcase. Eagerly importing the message
 * showcase chip would pull its fetch path and preview UI into the table bundle even when zero showcases render.
 *
 * Message prose imports {@link PrivateWorkspaceAgentPanelMessageShowcaseMoniker} directly when `@[showcase:…]`
 * appears in a turn; this wrapper code-splits via `React.lazy` alongside the share-link table moniker.
 * `Suspense` shows {@link WorkspaceAgentPendingPill} while the chunk loads, matching in-message pending UX.
 */
export const PrivateWorkspaceAgentTableShowcaseMoniker = memo(
  ({ collectionId }: PrivateWorkspaceAgentTableShowcaseMonikerProps) => (
    <Suspense fallback={<WorkspaceAgentPendingPill label="Showcase" />}>
      <ShowcaseMoniker collectionId={collectionId} />
    </Suspense>
  ),
);

PrivateWorkspaceAgentTableShowcaseMoniker.displayName = 'PrivateWorkspaceAgentTableShowcaseMoniker';
